module.exports = __webpack_public_path__ + "img/number-navigation.4f58aead.svg";